/* creoshop-favorites.js
   Heart/favorite toggle logic shared by product cards and the product page.
   Talks to the creoshop-favorites Railway service through the App Proxy at
   /apps/favorites. State (array of product handles) is cached in
   sessionStorage for 60s so multiple hearts on one page share one fetch.

   Buttons: <button data-creofav-toggle data-handle="..."> with
   data-creofav-guest present when no customer is logged in (click then
   redirects to login instead of calling the API). Active state is the
   .is-active class, styled by each template. */

(function () {
  'use strict';

  var API = '/apps/favorites';
  var CACHE_KEY = 'creofav';
  var CACHE_TTL = 60000;

  var state = null;      /* array of handles once loaded */
  var loadPromise = null;

  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (c && c.h && Date.now() - c.t < CACHE_TTL) return c.h;
    } catch (e) { /* noop */ }
    return null;
  }

  function writeCache(handles) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), h: handles }));
    } catch (e) { /* noop */ }
  }

  function isGuest() {
    var btn = document.querySelector('[data-creofav-toggle]');
    return btn ? btn.hasAttribute('data-creofav-guest') : false;
  }

  function load() {
    if (state) return Promise.resolve(state);
    var cached = readCache();
    if (cached) {
      state = cached;
      return Promise.resolve(state);
    }
    if (isGuest()) {
      state = [];
      return Promise.resolve(state);
    }
    if (!loadPromise) {
      loadPromise = fetch(API + '/list')
        .then(function (r) {
          if (!r.ok) throw new Error('list failed');
          return r.json();
        })
        .then(function (d) {
          state = d.favorites || [];
          writeCache(state);
          return state;
        })
        .catch(function () {
          state = [];
          return state;
        });
    }
    return loadPromise;
  }

  function paint(root) {
    if (!state) return;
    (root || document).querySelectorAll('[data-creofav-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var active = state.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      /* inline fill: immune to theme CSS specificity fights */
      var path = btn.querySelector('svg path');
      if (path) path.style.fill = active ? 'currentColor' : 'none';
    });
  }

  function post(path, handle) {
    return fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ handle: handle })
    }).then(function (r) {
      if (!r.ok) throw new Error('favorite request failed');
    });
  }

  function toggle(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;

    if (btn.hasAttribute('data-creofav-guest')) {
      window.location.href = '/account/login';
      return;
    }

    load().then(function () {
      var idx = state.indexOf(handle);
      var adding = idx === -1;

      /* optimistic */
      if (adding) state.push(handle);
      else state.splice(idx, 1);
      writeCache(state);
      paint();

      post(adding ? '/add' : '/remove', handle).catch(function () {
        /* revert on failure */
        var i = state.indexOf(handle);
        if (adding && i !== -1) state.splice(i, 1);
        else if (!adding && i === -1) state.push(handle);
        writeCache(state);
        paint();
      });
    });
  }

  /* Click delegation: survives cards injected after load (AJAX filtering,
     pagination, quickview). Heart sits above the card's overlay link, so
     stop the event before it bubbles into card navigation. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-creofav-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  /* Paint hearts added to the DOM after initial load. */
  var mo = new MutationObserver(function (mutations) {
    if (!state) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-creofav-toggle]')) paint(node.parentNode || document);
        else if (node.querySelector && node.querySelector('[data-creofav-toggle]')) paint(node);
      }
    }
  });

  function init() {
    if (!document.querySelector('[data-creofav-toggle]')) return;
    load().then(function () { paint(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
